import { RoundedError } from '@/components/icons'

export type ErrorMessageProps = {
  message: string | undefined
  className?: string
}

export const ErrorMessage = ({ message, className }: ErrorMessageProps) => {
  return (
    <>
      {message && (
        <div className={`flex flex-row gap-x-2 items-center text-boldOrange ${className ? className : ''}`}>
          <RoundedError height={24} width={24} />
          <p className="text-sm font-medium">{message}</p>
        </div>
      )}
    </>
  )
}

export default ErrorMessage
